module.exports = __webpack_public_path__ + "static/media/24.852fa537.wav";